function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import e from "morphdom";
var t = "5.0.0-pre9";
const n = {
    INPUT: !0,
    TEXTAREA: !0,
    SELECT: !0
  },
  o = {
    INPUT: !0,
    TEXTAREA: !0,
    OPTION: !0
  },
  r = {
    "datetime-local": !0,
    "select-multiple": !0,
    "select-one": !0,
    color: !0,
    date: !0,
    datetime: !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    textarea: !0,
    time: !0,
    url: !0,
    week: !0
  };
let s;
var a = {
  get element() {
    return s;
  },
  set(e) {
    s = e;
  }
};
const i = e => n[e.tagName] && r[e.type],
  l = e => {
    const t = (e && e.nodeType === Node.ELEMENT_NODE ? e : document.querySelector(e)) || a.element;
    t && t.focus && t.focus();
  },
  c = function (e, t) {
    let n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const o = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !0,
      detail: n
    });
    e.dispatchEvent(o), window.jQuery && window.jQuery(e).trigger(t, n);
  },
  u = e => document.evaluate(e, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue,
  d = e => Array(e).flat(),
  m = (e, t) => {
    Array.from(e.selectAll ? e.element : [e.element]).forEach(t);
  },
  h = e => e.split("").map((e, t) => e.toUpperCase() === e ? `${0 !== t ? "-" : ""}${e.toLowerCase()}` : e).join(""),
  p = (e, t) => !e.cancel && (e.delay ? setTimeout(t, e.delay) : t(), !0),
  f = (e, t) => c(e, `cable-ready:before-${h(t.operation)}`, t),
  b = (e, t) => c(e, `cable-ready:after-${h(t.operation)}`, t);
function y(e, t) {
  var _this = this;
  let n;
  return function () {
    for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
      o[_key] = arguments[_key];
    }
    clearTimeout(n), n = setTimeout(() => e.apply(_this, o), t);
  };
}
function g(e) {
  if (!e.ok) throw Error(e.statusText);
  return e;
}
async function w(e, t) {
  try {
    const n = await fetch(e, {
      headers: _objectSpread({
        "X-REQUESTED-WITH": "XmlHttpRequest"
      }, t)
    });
    if (null == n) return;
    return g(n), n;
  } catch (t) {
    console.error(`Could not fetch ${e}`);
  }
}
var E = Object.freeze({
  __proto__: null,
  isTextInput: i,
  assignFocus: l,
  dispatch: c,
  xpathToElement: u,
  getClassNames: d,
  processElements: m,
  operate: p,
  before: f,
  after: b,
  debounce: y,
  handleErrors: g,
  graciouslyFetch: w,
  kebabize: h
});
const v = e => (t, n) => !x.map(o => "function" != typeof o || o(e, t, n)).includes(!1),
  T = e => t => {
    M.forEach(n => {
      "function" == typeof n && n(e, t);
    });
  },
  A = (e, t, n) => !(!o[t.tagName] && t.isEqualNode(n)),
  S = (e, t, n) => t !== a.element || !t.isContentEditable,
  C = (e, t, n) => {
    const o = e.permanentAttributeName;
    if (!o) return !0;
    const r = t.closest(`[${o}]`);
    if (!r && t === a.element && i(t)) {
      const e = {
        value: !0
      };
      return Array.from(n.attributes).forEach(n => {
        e[n.name] || t.setAttribute(n.name, n.value);
      }), !1;
    }
    return !r;
  },
  x = [A, C, S],
  M = [];
var O = Object.freeze({
    __proto__: null,
    shouldMorphCallbacks: x,
    didMorphCallbacks: M,
    shouldMorph: v,
    didMorph: T,
    verifyNotMutable: A,
    verifyNotContentEditable: S,
    verifyNotPermanent: C
  }),
  k = {
    append: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.html,
            o = e.focusSelector;
          t.insertAdjacentHTML("beforeend", n || ""), l(o);
        }), b(t, e);
      });
    },
    graft: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.parent,
            o = e.focusSelector,
            r = document.querySelector(n);
          r && (r.appendChild(t), l(o));
        }), b(t, e);
      });
    },
    innerHtml: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.html,
            o = e.focusSelector;
          t.innerHTML = n || "", l(o);
        }), b(t, e);
      });
    },
    insertAdjacentHtml: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.html,
            o = e.position,
            r = e.focusSelector;
          t.insertAdjacentHTML(o || "beforeend", n || ""), l(r);
        }), b(t, e);
      });
    },
    insertAdjacentText: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.text,
            o = e.position,
            r = e.focusSelector;
          t.insertAdjacentText(o || "beforeend", n || ""), l(r);
        }), b(t, e);
      });
    },
    morph: t => {
      m(t, n => {
        const o = t.html,
          r = document.createElement("template");
        r.innerHTML = String(o).trim(), t.content = r.content;
        const s = n.parentElement,
          a = Array.from(s.children).indexOf(n);
        f(n, t), p(t, () => {
          const o = t.childrenOnly,
            s = t.focusSelector;
          e(n, o ? r.content : r.innerHTML, {
            childrenOnly: !!o,
            onBeforeElUpdated: v(t),
            onElUpdated: T(t)
          }), l(s);
        }), b(s.children[a], t);
      });
    },
    outerHtml: e => {
      m(e, t => {
        const n = t.parentElement,
          o = Array.from(n.children).indexOf(t);
        f(t, e), p(e, () => {
          const n = e.html,
            o = e.focusSelector;
          t.outerHTML = n || "", l(o);
        }), b(n.children[o], e);
      });
    },
    prepend: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.html,
            o = e.focusSelector;
          t.insertAdjacentHTML("afterbegin", n || ""), l(o);
        }), b(t, e);
      });
    },
    remove: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.focusSelector;
          t.remove(), l(n);
        }), b(document, e);
      });
    },
    replace: e => {
      m(e, t => {
        const n = t.parentElement,
          o = Array.from(n.children).indexOf(t);
        f(t, e), p(e, () => {
          const n = e.html,
            o = e.focusSelector;
          t.outerHTML = n || "", l(o);
        }), b(n.children[o], e);
      });
    },
    textContent: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.text,
            o = e.focusSelector;
          t.textContent = null != n ? n : "", l(o);
        }), b(t, e);
      });
    },
    addCssClass: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name;
          t.classList.add(...d(n || ""));
        }), b(t, e);
      });
    },
    removeAttribute: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name;
          t.removeAttribute(n);
        }), b(t, e);
      });
    },
    removeCssClass: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name;
          t.classList.remove(...d(n));
        }), b(t, e);
      });
    },
    setAttribute: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name,
            o = e.value;
          t.setAttribute(n, o || "");
        }), b(t, e);
      });
    },
    setDatasetProperty: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name,
            o = e.value;
          t.dataset[n] = o || "";
        }), b(t, e);
      });
    },
    setProperty: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name,
            o = e.value;
          n in t && (t[n] = o || "");
        }), b(t, e);
      });
    },
    setStyle: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name,
            o = e.value;
          t.style[n] = o || "";
        }), b(t, e);
      });
    },
    setStyles: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.styles;
          for (let _ref of Object.entries(n)) {
            var _ref2 = _slicedToArray(_ref, 2);
            let e = _ref2[0];
            let o = _ref2[1];
            t.style[e] = o || "";
          }
        }), b(t, e);
      });
    },
    setValue: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.value;
          t.value = n || "";
        }), b(t, e);
      });
    },
    dispatchEvent: e => {
      m(e, t => {
        f(t, e), p(e, () => {
          const n = e.name,
            o = e.detail;
          c(t, n, o);
        }), b(t, e);
      });
    },
    setMeta: e => {
      f(document, e), p(e, () => {
        const t = e.name,
          n = e.content;
        let o = document.head.querySelector(`meta[name='${t}']`);
        o || (o = document.createElement("meta"), o.name = t, document.head.appendChild(o)), o.content = n;
      }), b(document, e);
    },
    clearStorage: e => {
      f(document, e), p(e, () => {
        const t = e.type;
        ("session" === t ? sessionStorage : localStorage).clear();
      }), b(document, e);
    },
    go: e => {
      f(window, e), p(e, () => {
        const t = e.delta;
        history.go(t);
      }), b(window, e);
    },
    pushState: e => {
      f(window, e), p(e, () => {
        const t = e.state,
          n = e.title,
          o = e.url;
        history.pushState(t || {}, n || "", o);
      }), b(window, e);
    },
    redirectTo: e => {
      f(window, e), p(e, () => {
        let t = e.url,
          n = e.action;
        n = n || "advance", window.Turbo && window.Turbo.visit(t, {
          action: n
        }), window.Turbolinks && window.Turbolinks.visit(t, {
          action: n
        }), window.Turbo || window.Turbolinks || (window.location.href = t);
      }), b(window, e);
    },
    reload: e => {
      f(window, e), p(e, () => {
        window.location.reload();
      }), b(window, e);
    },
    removeStorageItem: e => {
      f(document, e), p(e, () => {
        const t = e.key,
          n = e.type;
        ("session" === n ? sessionStorage : localStorage).removeItem(t);
      }), b(document, e);
    },
    replaceState: e => {
      f(window, e), p(e, () => {
        const t = e.state,
          n = e.title,
          o = e.url;
        history.replaceState(t || {}, n || "", o);
      }), b(window, e);
    },
    scrollIntoView: e => {
      const t = e.element;
      f(t, e), p(e, () => {
        t.scrollIntoView(e);
      }), b(t, e);
    },
    setCookie: e => {
      f(document, e), p(e, () => {
        const t = e.cookie;
        document.cookie = t || "";
      }), b(document, e);
    },
    setFocus: e => {
      const t = e.element;
      f(t, e), p(e, () => {
        l(t);
      }), b(t, e);
    },
    setStorageItem: e => {
      f(document, e), p(e, () => {
        const t = e.key,
          n = e.value,
          o = e.type;
        ("session" === o ? sessionStorage : localStorage).setItem(t, n || "");
      }), b(document, e);
    },
    consoleLog: e => {
      f(document, e), p(e, () => {
        const t = e.message,
          n = e.level;
        n && ["warn", "info", "error"].includes(n) ? console[n](t || "") : console.log(t || "");
      }), b(document, e);
    },
    consoleTable: e => {
      f(document, e), p(e, () => {
        const t = e.data,
          n = e.columns;
        console.table(t, n || []);
      }), b(document, e);
    },
    notification: e => {
      f(document, e), p(e, () => {
        const t = e.title,
          n = e.options;
        Notification.requestPermission().then(o => {
          e.permission = o, "granted" === o && new Notification(t || "", n);
        });
      }), b(document, e);
    }
  };
let L = k;
const R = e => {
  L = _objectSpread(_objectSpread({}, L), e);
};
var P = {
  get all() {
    return L;
  }
};
const q = function (e) {
  let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    emitMissingElementWarnings: !0
  };
  const n = {};
  e.forEach(e => {
    e.batch && (n[e.batch] = n[e.batch] ? ++n[e.batch] : 1);
  }), e.forEach(e => {
    const o = e.operation;
    try {
      if (e.selector ? e.element = e.xpath ? u(e.selector) : document[e.selectAll ? "querySelectorAll" : "querySelector"](e.selector) : e.element = document, e.element || t.emitMissingElementWarnings) {
        a.set(document.activeElement);
        const t = P.all[o];
        t ? (t(e), e.batch && 0 == --n[e.batch] && c(document, "cable-ready:batch-complete", {
          batch: e.batch
        })) : console.error(`CableReady couldn't find the "${o}" operation. Make sure you use the camelized form when calling an operation method.`);
      }
    } catch (t) {
      e.element ? (console.error(`CableReady detected an error in ${o || "operation"}: ${t.message}. If you need to support older browsers make sure you've included the corresponding polyfills. https://docs.stimulusreflex.com/setup#polyfills-for-ie11.`), console.error(t)) : console.warn(`CableReady ${o || "operation"} failed due to missing DOM element for selector: '${e.selector}'`);
    }
  });
};
let H;
const N = [25, 50, 75, 100, 200, 250, 500, 800, 1e3, 2e3],
  I = async function () {
    let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    if (H) return H;
    if (e >= N.length) throw new Error("Couldn't obtain a Action Cable consumer within 5s");
    var t;
    return await (t = N[e], new Promise(e => setTimeout(e, t))), await I(e + 1);
  };
var U = {
  setConsumer(e) {
    H = e;
  },
  get consumer() {
    return H;
  },
  getConsumer: async () => await I()
};
class $ extends HTMLElement {
  disconnectedCallback() {
    this.channel && this.channel.unsubscribe();
  }
  createSubscription(e, t, n) {
    this.channel = e.subscriptions.create({
      channel: t,
      identifier: this.identifier
    }, {
      received: n
    });
  }
  get preview() {
    return document.documentElement.hasAttribute("data-turbolinks-preview") || document.documentElement.hasAttribute("data-turbo-preview");
  }
  get identifier() {
    return this.getAttribute("identifier");
  }
}
class _ extends $ {
  async connectedCallback() {
    if (this.preview) return;
    const e = await U.getConsumer();
    e ? this.createSubscription(e, "CableReady::Stream", this.performOperations) : console.error("The `stream_from` helper cannot connect without an ActionCable consumer.\nPlease run `rails generate cable_ready:helpers` to fix this.");
  }
  performOperations(e) {
    e.cableReady && q(e.operations);
  }
}
class j extends $ {
  constructor() {
    super();
    this.attachShadow({
      mode: "open"
    }).innerHTML = "\n<style>\n  :host {\n    display: block;\n  }\n</style>\n<slot></slot>\n";
  }
  async connectedCallback() {
    if (this.preview) return;
    this.update = y(this.update.bind(this), this.debounce);
    const e = await U.getConsumer();
    e ? this.createSubscription(e, "CableReady::Stream", this.update) : console.error("The `updates-for` helper cannot connect without an ActionCable consumer.\nPlease run `rails generate cable_ready:helpers` to fix this.");
  }
  async update(e) {
    const t = Array.from(document.querySelectorAll(this.query), e => new D(e));
    if (t[0].element !== this) return;
    a.set(document.activeElement), this.html = {};
    const n = [...new Set(t.map(e => e.url))];
    await Promise.all(n.map(async e => {
      if (!this.html.hasOwnProperty(e)) {
        const t = await w(e, {
          "X-Cable-Ready": "update"
        });
        this.html[e] = await t.text();
      }
    })), this.index = {}, t.forEach(t => {
      this.index.hasOwnProperty(t.url) ? this.index[t.url]++ : this.index[t.url] = 0, t.process(e, this.html, this.index);
    });
  }
  get query() {
    return `updates-for[identifier="${this.identifier}"]`;
  }
  get identifier() {
    return this.getAttribute("identifier");
  }
  get debounce() {
    return this.hasAttribute("debounce") ? parseInt(this.getAttribute("debounce")) : 20;
  }
}
class D {
  constructor(e) {
    this.element = e;
  }
  async process(t, n, o) {
    if (!this.shouldUpdate(t)) return;
    const r = o[this.url],
      s = document.createElement("template");
    this.element.setAttribute("updating", "updating"), s.innerHTML = String(n[this.url]).trim(), await this.resolveTurboFrames(s.content);
    const a = s.content.querySelectorAll(this.query);
    if (a.length <= r) return void console.warn(`Update aborted due to insufficient number of elements. The offending url is ${this.url}.`);
    const i = {
      element: this.element,
      html: a[r],
      permanentAttributeName: "data-ignore-updates"
    };
    c(this.element, "cable-ready:before-update", i), e(this.element, a[r], {
      childrenOnly: !0,
      onBeforeElUpdated: v(i),
      onElUpdated: e => {
        this.element.removeAttribute("updating"), c(this.element, "cable-ready:after-update", i), l(i.focusSelector);
      }
    });
  }
  async resolveTurboFrames(e) {
    const t = [...e.querySelectorAll('turbo-frame[src]:not([loading="lazy"])')];
    return Promise.all(t.map(t => new Promise(async n => {
      const o = await w(t.getAttribute("src"), {
          "Turbo-Frame": t.id,
          "X-Cable-Ready": "update"
        }),
        r = document.createElement("template");
      r.innerHTML = await o.text(), await this.resolveTurboFrames(r.content), e.querySelector(`turbo-frame#${t.id}`).innerHTML = String(r.content.querySelector(`turbo-frame#${t.id}`).innerHTML).trim(), n();
    })));
  }
  shouldUpdate(e) {
    return !this.ignoresInnerUpdates && this.hasChangesSelectedForUpdate(e);
  }
  hasChangesSelectedForUpdate(e) {
    const t = this.element.getAttribute("only");
    return !(t && e.changed && !t.split(" ").some(t => e.changed.includes(t)));
  }
  get ignoresInnerUpdates() {
    return this.element.hasAttribute("ignore-inner-updates") && this.element.hasAttribute("performing-inner-update");
  }
  get url() {
    return this.element.hasAttribute("url") ? this.element.getAttribute("url") : location.href;
  }
  get identifier() {
    return this.element.identifier;
  }
  get query() {
    return this.element.query;
  }
}
const F = e => {
    const t = e && e.parentElement.closest("updates-for");
    t && (t.setAttribute("performing-inner-update", ""), F(t));
  },
  z = e => {
    const t = e && e.parentElement.closest("updates-for");
    t && (t.removeAttribute("performing-inner-update"), z(t));
  },
  X = {
    perform: q,
    performAsync: function (e) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        emitMissingElementWarnings: !0
      };
      return new Promise((n, o) => {
        try {
          n(q(e, t));
        } catch (e) {
          o(e);
        }
      });
    },
    shouldMorphCallbacks: x,
    didMorphCallbacks: M,
    initialize: function () {
      let e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const t = e.consumer;
      document.addEventListener("stimulus-reflex:before", e => {
        F(e.detail.element);
      }), document.addEventListener("stimulus-reflex:after", e => {
        setTimeout(() => {
          z(e.detail.element);
        });
      }), document.addEventListener("turbo:submit-start", e => {
        F(e.target);
      }), document.addEventListener("turbo:submit-end", e => {
        setTimeout(() => {
          z(e.target);
        });
      }), t ? U.setConsumer(t) : console.error("CableReady requires a reference to your Action Cable `consumer` for its helpers to function.\nEnsure that you have imported the `CableReady` package as well as `consumer` from your `channels` folder, then call `CableReady.initialize({ consumer })`."), customElements.get("stream-from") || customElements.define("stream-from", _), customElements.get("updates-for") || customElements.define("updates-for", j);
    },
    addOperation: (e, t) => {
      const n = {};
      n[e] = t, R(n);
    },
    addOperations: e => {
      R(e);
    },
    version: t,
    cable: U,
    get DOMOperations() {
      return console.warn("DEPRECATED: Please use `CableReady.operations` instead of `CableReady.DOMOperations`"), P.all;
    },
    get operations() {
      return P.all;
    },
    get consumer() {
      return U.consumer;
    }
  };
window.CableReady = X;
export { O as MorphCallbacks, _ as StreamFromElement, $ as SubscribingElement, j as UpdatesForElement, E as Utils, X as default };